module.exports = __webpack_public_path__ + "bf227ee691828478869746021d155c0d.jpg";